import styled from 'styled-components';
import breakpoint from '@carvana/helios-layout/breakpoint';
import { text, background } from '@carvana/helios-styles';
import body from '@carvana/helios-typography/body';
import heading from '@carvana/helios-typography/heading';
import { LinkButton } from '@carvana/helios-navigation/linkButton';

const Container = styled.div`
  background-color: ${background.weak};
`;

const FAQSectionWrapper = styled.div`
  padding: 56px 24px;
  margin: auto;
  display: flex;
  flex-direction: column;

  ${breakpoint.sm`
    flex-direction: column;
    padding: 80px 32px;
  `}

  ${breakpoint.md`
    flex-direction: row;
    justify-content: space-between;
  `}

  ${breakpoint.xl`
    max-width: 1272px;
  `}
`;

const FAQHeader = styled.div`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: 16px;
`;

const SubText = styled.p`
  ${body.lg};
  color: ${text.default};
  margin-bottom: 40px;
`;

const FAQAccordionWrapper = styled.div`
  margin-bottom: 40px;

  ${breakpoint.md`
    max-width: 752px;
    margin-left: 132px;
    margin-top: -24px;
  `}
`;

const FAQButtonWrapper = styled.a`
  display: flex;
  margin: 0 auto;

  ${breakpoint.md`
    display: none;
  `}

  &.desktop-only {
    display: none;

    ${breakpoint.md`
      display: block;
      margin: 0;
    `}
  }

  button {
    width: 327px;

    ${breakpoint.sm`
      width: 182px;
    `}
  }
`;

const TextContainer = styled.div`
  ${breakpoint.md`
    max-width: 408px;
  `}
`;

const StyledLinkButton = styled(LinkButton)`
  text-align: left;
`;

const StyledUl = styled.ul`
  list-style: disc;

  && {
    padding-inline-start: 20px;
  }

  & strong {
    font-weight: 600;
  }

  & li {
    margin-bottom: 8px;

    &::marker {
      font-size: 13px;
    }

    &:first-child {
      margin-top: 8px;
    }
  }
`;

export {
  Container,
  FAQSectionWrapper,
  FAQHeader,
  FAQAccordionWrapper,
  FAQButtonWrapper,
  SubText,
  TextContainer,
  StyledLinkButton,
  StyledUl
};
